var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-toggle-card',{attrs:{"title":"Пунктирная линия","is-open":_vm.config.enabled},on:{"toggle":_vm.toggleProperty}})
}
var staticRenderFns = []

export { render, staticRenderFns }